/**
 * @deprecated StrictAutoplayEvents is left for backwards compatibility, use a GlobalEventsMap.
 */
export class AutoplayEvents {
    /**
     * @deprecated StrictAutoplayEvents.AUTOPLAY_START_SPIN is left for backwards compatibility, use event 'Autoplay.START' from GlobalEventsMap.
     */
    public static readonly AUTOPLAY_START_SPIN: symbol = Symbol('AUTOPLAY_START_SPIN');
    /**
     * @deprecated StrictAutoplayEvents.STOP_AUTOPLAY is left for backwards compatibility, use event 'Autoplay.STOPPED' from GlobalEventsMap.
     */
    public static readonly STOP_AUTOPLAY: symbol = Symbol('STOP_AUTOPLAY');
    /**
     * @deprecated StrictAutoplayEvents.START_AUTOPLAY is left for backwards compatibility, use event 'Autoplay.STARTED' from GlobalEventsMap.
     */
    public static readonly START_AUTOPLAY: symbol = Symbol('START_AUTOPLAY');
    /**
     * @deprecated StrictAutoplayEvents.FORCE_STOP_AUTOPLAY is left for backwards compatibility,
     * use event 'Autoplay.FORCE_STOP' from GlobalEventsMap.
     */
    public static readonly FORCE_STOP_AUTOPLAY: symbol = Symbol('FORCE_STOP_AUTOPLAY');
}
